// extracted by mini-css-extract-plugin
export var button = "Accordion-module--button--269+Z";
export var component = "Accordion-module--component--uTPUP";
export var content = "Accordion-module--content--ss-MQ";
export var hidden = "Accordion-module--hidden--k2eeM";
export var icon = "Accordion-module--icon--C+STA";
export var list = "Accordion-module--list--OtOTn";
export var row = "Accordion-module--row--oLfAP";
export var title = "Accordion-module--title--73Tnp";